import React, { useMemo, useRef } from 'react'

import MyDocumentsTile from './MyDocumentsTile'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { TripDocumentWithItemInfo } from 'tripPlanner/types/documents'
import { sortBy } from 'lib/array/arrayUtils'

interface Props {
  tripId: string
  tripItemId?: string
  documents: Array<TripDocumentWithItemInfo>
}

function MyDocuments({ tripId, tripItemId, documents }: Props) {
  // We want to persist the same order of items so that when an item
  // is attached/detached it doesn't move around.
  const previousOrderMapRef = useRef<Map<string, number>>(new Map())

  const allDocuments = useMemo(() => {
    const updatedDocuments = documents

    if (!previousOrderMapRef.current.size) {
      // Order has not been set yet
      // Let's set the order now based on the filtered documents order
      const currentOrderMap = new Map<string, number>()
      updatedDocuments.forEach((doc, index) => {
        currentOrderMap.set(doc.filename, index)
      })

      previousOrderMapRef.current = currentOrderMap

      return updatedDocuments
    } else {
      // Order has been set, let's sort the documents based on the previous order
      return sortBy(updatedDocuments, (document) => previousOrderMapRef.current.get(document.filename), 'asc')
    }
  }, [documents])

  return (
    <VerticalSpacer gap={16}>
      {allDocuments?.map((document) => (
        <MyDocumentsTile
          document={document}
          tripId={tripId}
          tripItemId={tripItemId}
          key={document.key}
        />
      ))}
    </VerticalSpacer>
  )
}

export default MyDocuments
